import styled, { css } from 'styled-components'

import crossIcon from '../../../../assets/svgs/cross_icon.svg'
import { theme } from '../../../theme'
import { Button } from '../Button'

import type { ModalHeaderStyleProps, ModalStyleProps } from './types'

const SlideAsideHeader = css`
  padding: 20px 50px;
  border-bottom: 1px solid ${theme.colors.solitude};
`

const CenterHeader = css`
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
`

const LeftHeader = css`
  padding: 20px 40px;
  text-align: left;

  &::after {
    content: '';
    height: 1px;
    display: block;
    width: 100%;
    position: absolute;
    color: green;
    left: 0;
    margin-top: 20px;
    border-bottom: 1px solid ${theme.colors.solitude};
  }
`

const getHeaderStyle = (slideAside: boolean, leftHeader: boolean) => {
  if (slideAside) {
    return SlideAsideHeader
  }
  if (leftHeader) {
    return LeftHeader
  }
  return CenterHeader
}

export const ModalContent = styled.div<{ $isScrollable: boolean }>`
  ${({ $isScrollable }) =>
    $isScrollable &&
    css`
      border-radius: 16px;
      max-height: 80vh;
      overflow-y: scroll;
      ::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;
    `}
`
export const ModalHeader = styled.div<ModalHeaderStyleProps>`
  ${({ slideAside, leftHeader }) => getHeaderStyle(slideAside, leftHeader)}
  font-family: ${theme.fonts.mainFont};
  color: ${theme.colors.sapphireDark};
  font-weight: 500;
  font-size: 22px;
  line-height: 27px;
  ${({ $isScrollable }) =>
    $isScrollable &&
    css`
      position: absolute;
      height: 70px;
      z-index: 1;
      width: 100%;
      border-radius: 16px 16px 16px 0px;
      background-color: ${theme.colors.white};
    `}
`

export const ModalContainer = styled.div<ModalStyleProps>`
  padding: ${({ slideAside }) => (slideAside ? '30px 50px' : 0)};
  margin-top: ${({ $isScrollable }) => (!$isScrollable ? 0 : '70px')};
`

export const CloseButton = styled.button<ModalStyleProps>`
  position: absolute;
  border: none;
  width: ${({ slideAside, leftHeader }) =>
    `${slideAside || leftHeader ? 20 : 12}px`};
  height: ${({ slideAside, leftHeader }) =>
    `${slideAside || leftHeader ? 20 : 12}px`};
  right: ${({ slideAside, leftHeader }) =>
    `${slideAside || leftHeader ? 20 : 15}px`};
  top: ${({ slideAside, leftHeader }) =>
    `${slideAside || leftHeader ? 24 : 15}px`};
  background-color: ${theme.colors.white};

  background-image: url(${crossIcon});
  background-position: center;
  background-size: ${({ slideAside, leftHeader }) =>
    `${slideAside || leftHeader ? 20 : 12}px`};
  background-repeat: no-repeat;
`

export const EditButton = styled(Button)`
  margin-left: 30px;
`
